import React from 'react';
import { motion, useScroll, useSpring, useTransform } from 'framer-motion';
import { clampProgress } from '../../lib/motion';

// Fil bleu sous la barre de navigation : la part de la page déjà lue (0 → 1).
// La progression est bornée (une page non défilable rend NaN) et lissée par un ressort.
export default function ScrollProgress({ visible = true }) {
  const { scrollYProgress } = useScroll();
  const progress = useTransform(scrollYProgress, clampProgress);
  const scaleX = useSpring(progress, { stiffness: 180, damping: 30, mass: 0.3 });
  return (
    <motion.div
      aria-hidden="true"
      data-testid="scroll-progress"
      className={`absolute left-0 right-0 bottom-0 h-[2px] origin-left bg-[#0099D6] transition-opacity duration-300 ${
        visible ? 'opacity-100' : 'opacity-0'
      }`}
      style={{ scaleX }}
    />
  );
}
